var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage70({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.567 7.09.999 2.295a.5.5 0 0 0 .183.084 1 1 0 0 0 .502 0q.117-.03.183-.084l1.002-2.295H15.5a.9.9 0 0 0 .354-.067c.093-.042.146-.1.146-.16V3.227c0-.06-.053-.118-.146-.16A.9.9 0 0 0 15.5 3h-11a.9.9 0 0 0-.354.067c-.093.042-.146.1-.146.16v3.636c0 .06.053.118.146.16a.9.9 0 0 0 .354.067zM12 15c1.227 0 2.5.5 3 2m-7-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-3 2a3.8 3.8 0 0 1 1.272-1.465A3.1 3.1 0 0 1 8 16c.606 0 1.201.184 1.728.535S10.692 17.391 11 18m-.603-6.269q.078-.095.17-.18a2.06 2.06 0 0 1 2.106-.427c.356.13.668.355.9.65a1.98 1.98 0 0 1 .22 2.106 2 2 0 0 1-.75.817A2.06 2.06 0 0 1 11.97 15"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage70);
export default __webpack_public_path__ + "static/media/image70.df1cfb6af74264046bec623673b0982e.svg";
export { ForwardRef as ReactComponent };